module.exports = "pegasus_template/assets/circle_x_gray.png";